module.exports = __webpack_public_path__ + "img/home_menu_15_default.c14321aa.png";